import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WorkAccidentFilterInput } from '../../core/interfaces/work-accident-filter-input';

@Injectable()
export class SStatsCardWorkAccidentService {

    private readonly endpointQuery = "hcm/analytics_sst/queries";

    constructor(private readonly httpClient: HttpClient) {}

    totalizerAccidentsCardsCount(filter: WorkAccidentFilterInput) {
        return this.httpClient.post(`${this.endpointQuery}/employeeWorkAccidentTotalizerQuery`, {
            ...filter
        });
    }
}
